import React from 'react';
import VideocamIcon from '@mui/icons-material/Videocam';
import { Box } from '@mui/material';
import type { DisplayedFile } from '../../../gallery/filesStore';
import { fileKindService } from 'services/fileService';
import {
  listImageIconContainerSx,
  listImageVideoContainerSx,
  listImageVideoPreviewSx,
} from '../../styles';
import { ListItemFrame, type ListItemFrameProps } from './ListItemFrame';

interface VideoListItemProps extends ListItemFrameProps {
  image: DisplayedFile;
  videoPreviewError: boolean;
  onVideoPreviewError: () => void;
}

/** A tile of a video: its first frame, or a camera icon when the preview cannot be played. */
export const VideoListItem: React.FC<VideoListItemProps> = ({
  image,
  videoPreviewError,
  onVideoPreviewError,
  ...frameProps
}) => {
  const { onClick } = frameProps;
  const videoSource = fileKindService.resolveVideoPreviewSource(image);
  const videoMimeType = fileKindService.resolveVideoMimeType(image);

  return (
    <ListItemFrame {...frameProps}>
      {videoSource && !videoPreviewError ? (
        <Box onClick={onClick} sx={listImageVideoContainerSx}>
          <video
            key={videoSource}
            crossOrigin='use-credentials'
            preload='metadata'
            muted
            playsInline
            style={listImageVideoPreviewSx}
            onError={onVideoPreviewError}
          >
            <source src={videoSource} type={videoMimeType} />
          </video>
        </Box>
      ) : (
        <Box onClick={onClick} sx={listImageIconContainerSx}>
          <VideocamIcon />
        </Box>
      )}
    </ListItemFrame>
  );
};
